/* Niclas + ChatGPT | 2026-10-02 | Preserve US/CA → EU suggestion; accessible dismissal. */
(function () {
  const host = location.hostname.replace(/^www\./, '');
  if (!['us.avolt.com', 'ca.avolt.com'].includes(host)) return;
  if (/googlebot|bingbot|adsbot|duckduckbot|yandexbot|baiduspider|slackbot|twitterbot|linkedinbot|gptbot|oai-searchbot/i.test(navigator.userAgent || '')) return;
  const key = `avolt_notified_eu_${host}`;
  try { if (sessionStorage.getItem(key)) return; } catch {}
  const modal = document.getElementById('avoltStoreModal');
  const go = document.getElementById('avoltGoEU');
  const stay = document.getElementById('avoltStayNA');
  if (!modal || !go || !stay) return;
  const root = window.Shopify?.routes?.root || '/';
  fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`)
    .then(res => res.json())
    .then(data => {
      const country = data.detected_values?.country?.handle;
      if (!country || ['US', 'CA'].includes(country)) return;
      stay.textContent = host === 'ca.avolt.com' ? 'Stay on Canadian store' : 'Stay on US store';
      let previousFocus;
      const close = () => {
        try { sessionStorage.setItem(key, 'true'); } catch {}
        modal.classList.remove('is-visible');
        modal.setAttribute('aria-hidden', 'true');
        previousFocus?.focus();
      };
      go.onclick = () => {
        const path = location.pathname;
        location.href = 'https://avolt.com' + (path.includes('/collections/') ? path : '/');
      };
      stay.onclick = close;
      modal.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key === 'Tab') {
          if (event.shiftKey && document.activeElement === go) { event.preventDefault(); stay.focus(); }
          else if (!event.shiftKey && document.activeElement === stay) { event.preventDefault(); go.focus(); }
        }
      });
      setTimeout(() => {
        previousFocus = document.activeElement;
        modal.classList.add('is-visible');
        modal.setAttribute('aria-hidden', 'false');
        go.focus();
      }, 800);
    }).catch(() => {});
})();
